import { Dropdown } from 'components/common'
import { FilterTextInput } from 'components/common/logFilterInputs'
import useLogFilters from 'hooks/useLogFilters'
import {
  ACTIVE_OPTIONS,
  FILTER_FIELD_CRON_JOBS,
  getGroupOptions,
  HEALTH_OPTIONS,
  STATUS_OPTIONS,
} from './utils'

type Props = {
  groups: string[]
}

const DROPDOWNS = [
  { name: 'active', label: 'Enabled', options: ACTIVE_OPTIONS },
  { name: 'status', label: 'Status', options: STATUS_OPTIONS },
  { name: 'health', label: 'Health', options: HEALTH_OPTIONS },
]

// Auto-applying filter bar; values live in the URL (same as the log pages)
const CronJobFilters = ({ groups }: Props) => {
  const { filters, setField } = useLogFilters(FILTER_FIELD_CRON_JOBS)

  return (
    <div className="mb-3 flex flex-wrap items-end gap-3 rounded-xl border border-gray-200 bg-white px-4 py-3 shadow-sm">
      <FilterTextInput
        label="Search"
        value={filters.search || ''}
        onApply={(value) => setField('search', value)}
        placeholder="Name, title or description"
      />

      <div className="min-w-[180px]">
        <Dropdown
          name="group"
          label="Group"
          options={getGroupOptions(groups)}
          defaultValue={filters.group || ''}
          setValue={(_field: string, value: string) => setField('group', value)}
        />
      </div>

      {DROPDOWNS.map(({ name, label, options }) => (
        <div key={name} className="min-w-[150px]">
          <Dropdown
            name={name}
            label={label}
            options={options}
            searchable={false}
            defaultValue={filters[name] || ''}
            setValue={(_field: string, value: string) => setField(name, value)}
          />
        </div>
      ))}
    </div>
  )
}

export default CronJobFilters
